import { Injectable } from '@angular/core';
import { BookingSlotSelectPolicyEnum } from '../../booking/services/booking-slot-select-policy.enum';
import { DayOfWeek } from '../../booking/models/day-of-week';
import { TimeRestriction } from '../../booking/models/time-restriction';
import { ShopSettings } from '../../booking/models/shop-settings';
import { ShopSettingsService } from './shop-settings.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class CalendarService {

  protected _disabledDaysOfWeek: Array<number> = [];
  protected shopSettingsService: ShopSettingsService;

  constructor(
  ) { }

  dateSelect(
    date: Date,
    bookingSlotSelectPolicy: BookingSlotSelectPolicyEnum = BookingSlotSelectPolicyEnum.FirstSlot,
    searchDirection: number = 1,
  ): Observable<boolean> {
    return of(true);
  }

  get disabledDaysOfWeek(): Array<number> {
    return this._disabledDaysOfWeek;
  }

  get selectedDate(): Date  {
    return null;
  }

  get isEvent(): boolean {
    return false;
  }

  isDateEnabled(date: Date): boolean {
    const res = date && ((this.disabledDaysOfWeek.indexOf(date.getDay()) > -1) ||
      (this.shopSettingsService.getMinDate(this.isEvent) && date < this.shopSettingsService.getMinDate(this.isEvent)) ||
      (this.shopSettingsService.getMaxDate(this.isEvent) && date > this.shopSettingsService.getMaxDate(this.isEvent)))
      ? false : true;
    return res;
  }
}
